import List from 'components/Common/List'
import Accordion from 'LuxKit/Accordion'
import HTMLRender from 'LuxKit/HTMLRender'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { useIntl } from 'react-intl'
import LargeContentToggle from 'components/Common/LargeContentToggle'

interface Props {
  offer: App.MerchandiseOffer
}

function MerchandiseOfferPageOverviewSection(props: Props) {
  const { offer } = props
  const intl = useIntl()

  return <div>
    {offer.copy.description && <Accordion
      heading={intl.formatMessage({
        id: 'L36y+kSMAc',
        defaultMessage: 'Overview',
        description: 'Accordion heading for product overview section',
      })}
      defaultOpen
    >
      <LargeContentToggle
        maxHeight={208}
        showMoreText={intl.formatMessage({
          id: 'pO7Rlj5pDg',
          defaultMessage: 'Read more',
          description: 'Button text to expand content',
        })}
        showLessText={intl.formatMessage({
          id: '/eVNUVYLiw',
          defaultMessage: 'Read less',
          description: 'Button text to collapse content',
        })}
      >
        <HTMLRender content={offer.copy.description} />
      </LargeContentToggle>
    </Accordion>}
    {!!offer.copy.features.length && <Accordion heading={intl.formatMessage({
      id: 'mHE6miwFvQ',
      defaultMessage: 'Features',
      description: 'Accordion heading for product features section',
    })}
    >
      <List spaced>
        {offer.copy.features.map(feature => <BodyText
          variant="medium"
          as="li"
          colour="neutral-two"
          key={feature}
        >
          {feature}
        </BodyText>)}
      </List>
    </Accordion>}
    {offer.copy.specifications && <Accordion heading={intl.formatMessage({
      id: 'E5SrLCGZCv',
      defaultMessage: 'Specifications',
      description: 'Accordion heading for product specifications section',
    })}
    >
      <HTMLRender content={offer.copy.specifications} />
    </Accordion>}
    {offer.copy.shippingPolicy && <Accordion heading={intl.formatMessage({
      id: 'c1XDWmTCb7',
      defaultMessage: 'Shipping information',
      description: 'Accordion heading for shipping policy section',
    })}
    >
      <HTMLRender content={offer.copy.shippingPolicy} />
    </Accordion>}
    {offer.copy.returnPolicy && <Accordion heading={intl.formatMessage({
      id: 'Ukm+OyAbpf',
      defaultMessage: 'Returns information',
      description: 'Accordion heading for returns policy section',
    })}
    >
      <HTMLRender content={offer.copy.returnPolicy} />
    </Accordion>}
  </div>
}

export default MerchandiseOfferPageOverviewSection
